export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_demandDate') || '需求日期',
    field: 'demandDate',
    align: 'center',
    width: 170,
    editRender: {
      name: 'ElDatePicker',
      props: {
        placeholder: that.$l('INDEX.tips_select_date') || '选择日期',
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleType') || '样品类型',
    field: 'proofingType',
    align: 'center',
    minWidth: 160,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'proofingType' },
        url: '/master/common/dict/biz',
        placeholder: that.$l('INDEX.tips_select_data') || '请选择...',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_demandQty') || '样品数量',
    field: 'demandQty',
    align: 'center',
    width: 160,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        'controls-position': 'right',
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_demandRemark') || '交付要求',
    field: 'demandRemark',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        'show-word-limit': true,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
  },
]
